exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon{\r\n    height: 20px;\r\n    width: 20px;\r\n    background-size: 100px 82px;\r\n    margin: 3px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--7-1!./node_modules/postcss-loader/lib??postcss!./src/css/icons.css
// module id = ./node_modules/css-loader/index.js??ref--7-1!./node_modules/postcss-loader/lib/index.js??postcss!./src/css/icons.css
// module chunks = styles